<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    :width="width"
    :height="height"
  >
    <path d="M28 7V25C28 25.2652 27.8946 25.5196 27.7071 25.7071C27.5196 25.8946 27.2652 26 27 26H5C4.73478 26 4.48043 25.8946 4.29289 25.7071C4.10536 25.5196 4 25.2652 4 25V7C4 6.73478 4.10536 6.48043 4.29289 6.29289C4.48043 6.10536 4.73478 6 5 6H27C27.2652 6 27.5196 6.10536 27.7071 6.29289C27.8946 6.48043 28 6.73478 28 7Z" opacity="0.1" />
    <path d="M16 16C16.0001 16.15 15.9664 16.2981 15.9015 16.4334C15.8366 16.5686 15.7421 16.6875 15.625 16.7812L10.625 20.7812C10.5224 20.8633 10.4046 20.9244 10.2785 20.961C10.1523 20.9975 10.0201 21.0089 9.88951 20.9944C9.75893 20.9799 9.63249 20.9398 9.5174 20.8764C9.40231 20.813 9.30083 20.7276 9.21875 20.625C9.13667 20.5224 9.07561 20.4046 9.03904 20.2785C9.00247 20.1523 8.99112 20.0201 9.00563 19.8895C9.02014 19.7589 9.06023 19.6325 9.1236 19.5174C9.18698 19.4023 9.2724 19.3008 9.375 19.2188L13.3988 16L9.375 12.7812C9.2724 12.6992 9.18698 12.5977 9.1236 12.4826C9.06023 12.3675 9.02014 12.2411 9.00563 12.1105C8.99112 11.9799 9.00247 11.8477 9.03904 11.7215C9.07561 11.5954 9.13667 11.4776 9.21875 11.375C9.30083 11.2724 9.40231 11.187 9.5174 11.1236C9.63249 11.0602 9.75893 11.0201 9.88951 11.0056C10.0201 10.9911 10.1523 11.0025 10.2785 11.039C10.4046 11.0756 10.5224 11.1367 10.625 11.2188L15.625 15.2188C15.7421 15.3125 15.8366 15.4314 15.9015 15.5666C15.9664 15.7019 16.0001 15.85 16 16ZM22 19H17C16.7348 19 16.4804 19.1054 16.2929 19.2929C16.1054 19.4804 16 19.7348 16 20C16 20.2652 16.1054 20.5196 16.2929 20.7071C16.4804 20.8946 16.7348 21 17 21H22C22.2652 21 22.5196 20.8946 22.7071 20.7071C22.8946 20.5196 23 20.2652 23 20C23 19.7348 22.8946 19.4804 22.7071 19.2929C22.5196 19.1054 22.2652 19 22 19ZM29 7V25C29 25.5304 28.7893 26.0391 28.4142 26.4142C28.0391 26.7893 27.5304 27 27 27H5C4.46957 27 3.96086 26.7893 3.58579 26.4142C3.21071 26.0391 3 25.5304 3 25V7C3 6.46957 3.21071 5.96086 3.58579 5.58579C3.96086 5.21071 4.46957 5 5 5H27C27.5304 5 28.0391 5.21071 28.4142 5.58579C28.7893 5.96086 29 6.46957 29 7ZM27 25V7H5V25H27Z" />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 32,
    },
    height: {
      type: [Number, String],
      default: 32,
    },
  },
}
</script>

